import  { useContext, useState, useEffect, useRef} from "react";
import { Switch, Route, useLocation, useRouteMatch, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
 IonItem,
 IonToolbar,
 IonItemDivider,
 IonLabel,
 IonButtons,
 IonSearchbar,
 IonSegmentButton,
 IonSegment,
 IonButton,
 IonHeader,
 IonPage,
 IonContent,
 IonFooter,
 isPlatform,
 IonToast,
 IonIcon
} from "@ionic/react";
import { logoGooglePlaystore, logoAppleAppstore } from "ionicons/icons";
import { SwipeableDrawer, Menu } from "@material-ui/core";
import { ArrowBackSharp, Feedback, FilterList, HighlightOff, History, InfoSharp, MenuSharp, SecuritySharp, SettingsSharp, ShareSharp, VolunteerActivismSharp } from "@mui/icons-material";
import { QueueMusicSharp, MenuBookSharp, AutoStoriesSharp } from "@mui/icons-material";
import { Share } from "@capacitor/share";
import { AnimatePresence, motion } from "framer-motion";

import { Colour, FontType, IskconContent, Hindit, SearchHistory } from "../global";
import logo from "../../splash.jpg";
import SP from "../../sp.svg";
import Settings from "../menu/settings";
import Csong from "./hsong";
import About from "../menu/about";

import TempleFilter from "./filters/temple";
import AstakamFilter from "./filters/astakams";
import PranamaFilter from "./filters/pranama";
import AuthorFilter from "./filters/author";
import { OndemandVideoSharp, PlayLessonSharp } from "@mui/icons-material";
import Donate from "../menu/donate";
import Privacy from "../menu/privacy";
import Terms from "../menu/terms";
import { LaunchReview } from "@awesome-cordova-plugins/launch-review"

function Csub() {
 let { path, url } = useRouteMatch();
 let location = useLocation();
 const [searchText, setSearchText] = useState("");
 const [searchState, setSearchState] = useState(false);
 const [drawerstate, setDrawer] = useState(false);
 const [font,] = useContext(FontType);
 const [showToast, setShowToast] = useState(false);
 const [toastText, setToastText] = useState();
 let fon;
 if (!font) fon = "Calibri, sans-serif";
 else fon = "Times New Roman, serif";
 const [clr,] = useContext(Colour);
 let color, color2, color3, colori, colorh, color4, colorsp;
 if(clr === "1") {
  color = "";
  color2 = "#00CBFE";
  color3 = "white"
  colori = ""
  colorh = "primary"
  colorsp = "#3880ff"
  color4 = "black"
 }
 if(clr === "2") {
  color = "#FCEFAA";
  color2 = "#FFE34D";
  color3 = "black"
  colori = "secondary"
  colorh = "warning"
  colorsp = "#F5CA16"
  color4 = "black"
 }
 if(clr === "3") {
  color = "#FCEFAA";
  color2 = "#FFA500";
  color3 = "black"
  colori = "secondary"
  colorh = "success"
  colorsp = "#FF9933"
  color4 = "black"
 }
 if(clr === "4") {
  color = "#FCEFAA";
  color2 = "#87CEEB";
  color3 = "black"
  colori = "secondary"
  colorh = "tertiary"
  colorsp = "#6FB1FC"
  color4 = "black"
 }
 if(clr === "5") {
  color = "#121212";
  color2 = "#FFE34D";
  color3 = "black"
  colori = "dark"
  colorh = "warning"
  colorsp = "#F5CA16"
  color4 = "white"
 }
 if(clr === "6") {
  color = "#121212";
  color2 = "#87CEEB";
  color3 = "black"
  colori = "dark"
  colorh = "tertiary"
  colorsp = "#6FB1FC"
  color4 = "white"
 }
 const [anchorEl, setAnchorEl] = useState(null);

 const [iskcon2,] = useContext(IskconContent);
const [iskcon, setIskcon] = useState({ scontent: "", songs: [], author: [] });
 const [searchList, setSearchList] = useState([]);
 const [spos, setSpos] = useState(0);
 let history = useHistory();
 const [filter, setFilter] = useState("all");
 const [hindit,] = useContext(Hindit);
 const [searchHistory, setSearchHistory] = useContext(SearchHistory)
 let scrollBar= ["A", "B", "C", "D", "E", "G", "H", "I", "J", "K", "M", "N", "O", "P", "R", "S", "T", "U", "V", "Y"];
 const contentRef = useRef();
 let locy = 0;

useEffect(() => {
  let newSongs = {...iskcon2};
  newSongs.songs=[];
  for (let i = 0; i < 20; i++) {
    newSongs.songs.push(iskcon2.songs[i]);
  }
  setIskcon(newSongs);
  setTimeout(function () {
    setIskcon(iskcon2);
   }, 1);
}, [filter]);

 useEffect(() => {
  if (location.pathname === url && contentRef.current) contentRef.current.scrollToPoint(0,spos);
 }, [location, contentRef.current]);

 const useStyles = makeStyles({
  paper: {
   background: `${color}`,
  
  },
 });
 const classes = useStyles();

 const search = (text)=>{
  setSearchText(text)
  window.scrollTo(0, 0);
  let query = text
   .toLowerCase()
   .replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, " ")
   .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
   .replace(/krishna/g, "krsna")
   .replace(/gor/g, "gaur")
   .replace(/gour/g, "gaur")
   .replace(/\s{2,}/g, " ");

  let niskcon = { ...iskcon };           
  iskcon.songs.map((td, i) => {
   let show =
    td.name.toLowerCase()
    .replace(/krishna/g, "krsna")
    .replace(/gor/g, "gaur")
    .replace(/gour/g, "gaur")
    .indexOf(query) > -1 || (td.hindi && td.hindi.indexOf(query) > -1)  || (td.offical && td.offical
     .replace(/krishna/g, "krsna")
     .replace(/gor/g, "gaur")
     .replace(/gour/g, "gaur")
     .toLowerCase().replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, " ").toLowerCase().indexOf(query) > -1)
   niskcon.songs[i].state = show;
   return null
  });
  setIskcon(niskcon);

 if (!hindit){
   let titles = [];
   for (let i=0; i<iskcon.songs.length; i++){
     let song_text = iskcon.songs[i].body.slice(iskcon.songs[i].body.indexOf("(1)"))
     .replace(/krishna/g, "krsna")
     .replace(/gor/g, "gaur")
     .replace(/gour/g, "gaur")
     .toLowerCase().replace("(refrain)", "(0)").replace("refrain:", "0)").replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, " ").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
     let query_index = song_text.indexOf(query)
     if (query_index !== -1) {
       let line = song_text.slice(song_text.lastIndexOf("\n", query_index), song_text.indexOf("\n", query_index))
       let query_start = line.indexOf(query)
       titles.push({index: i, line: line, start: query_start, end: query_start+query.length})
     }
   }
   setSearchList(titles);
 }
 }

 return (
  <div style={{ backgroundColor: `${color}` }}>
   <AnimatePresence onExitComplete>
  <>
  <div className="print-hide">
 <IonPage className="print-hide">
        <IonHeader>
      <IonToolbar color={colorh}>
       {filter === "all" && !searchState ? (
        <IonButtons style={{height:"52px"}} slot="start">
          <IonButton  onClick={() => setDrawer(true)}>  
          <MenuSharp />
          </IonButton>
        </IonButtons>
       ) : (
        <IonButtons
         slot="start"
         style={ (searchState ? ({height:"52px"}) : null)}
        >
          <IonButton
            onClick={() => {
            setFilter("all");
            setSearchText("");
            setSearchState(false);
            }}
          >
             <ArrowBackSharp style={{ fontSize: 30 }} />
          </IonButton>
        </IonButtons>
       )}
       {filter === "all" ? (
        <>
         {" "}
         <IonSearchbar
          color={colori}
          value={searchText}
          style={{ padding: 0}}
          type="text"
          onIonInput={(e) => {
           search(e.detail.value)
          }}
          debounce={1000}
          onIonFocus={()=>{
            setSearchState(true)
          }}
          onIonClear={() => {
           window.scrollTo(0, 0);
          }}
         ></IonSearchbar>
         {searchState ? (
          <IonButtons style={{height:"52px"}} slot="end">
           <IonButton
            onClick={() => {
             history.push(`/history`);
            }}
           >
            <History />
           </IonButton>
           <IonButton
            onClick={(e) => {
              setFilter("all");
              setSearchText("");
              setSearchState(false);
            }}
           >
            <HighlightOff />
           </IonButton>
          </IonButtons>
         ) : (
          <IonButtons style={{height:"52px"}} slot="end">
           <IonButton
            onClick={() => {
             history.push(`${url}/settings`);
            }}
           >
            <SettingsSharp />
           </IonButton>
           <IonButton
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={(e) => {
             if (hindit) {
              if (filter === "all") setFilter("temple");
              else setFilter("all");
             } else setAnchorEl(e.currentTarget);
            }}
           >
            <FilterList />
           </IonButton>
          </IonButtons>
         )}
        </>
       ) : (
        <>
         <IonButtons slot="start">
          {filter === "authors" ? <IonLabel style={{ marginLeft: "10px", fontFamily: `${fon}` }}>Authors</IonLabel> : null}
          {filter === "temple" ? <IonLabel style={{ marginLeft: "10px", fontFamily: `${fon}` }}>{hindit ? "मंदिर आरती गीत" : "Temple Songs"}</IonLabel> : null}
          {filter === "pranama" ? <IonLabel style={{ marginLeft: "10px", fontFamily: `${fon}` }}>Pranama Mantras</IonLabel> : null}
          {filter === "astakams" ? <IonLabel style={{ marginLeft: "10px", fontFamily: `${fon}` }}>Ashtakams & Stotras</IonLabel> : null}
         </IonButtons>

         <IonButtons slot="end">
          <IonButton
           aria-controls="simple-menu"
           aria-haspopup="true"
           onClick={(e) => {
            if (hindit) {
             if (filter === "all") setFilter("temple");
             else setFilter("all");
            } else setAnchorEl(e.currentTarget);
           }}
          >
           <FilterList />
          </IonButton>
         </IonButtons>
        </>
       )}
      </IonToolbar>
      </IonHeader>
      <IonContent id="ionc" onIonScroll={(e)=>{
        locy = e.detail.scrollTop;
      }} onIonScrollEnd = {()=>{setSpos(locy)}} ref={contentRef} scrollEvents={true} color={colori}>

      <div style={{ height: "2px" }}></div>
      <SwipeableDrawer classes={{ paper: classes.paper }} anchor="left" open={drawerstate} onOpen={() => setDrawer(true)} onClose={() => setDrawer(false)}>
       <IonHeader>
        <IonToolbar color={colorh} style={{height:"0"}}> 
       </IonToolbar>
       </IonHeader>
       <img src={logo} style={{ width: "275px" }} alt="Gauranga is Radha & Krishna combined"></img>
       <IonItem button={isPlatform('desktop') ? true : false}         color={colori}
       
        onClick={() => {
         if (hindit) {
          window.location.href = "https://youtu.be/2_1wsroha9Q";
         } else {
          window.location.href = "https://youtu.be/d0ElUEzFM_g";
         }
        }}
       >
        <OndemandVideoSharp style={{ paddingRight: "10px" }} />
        <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "वीडियो ट्यूटोरियल" : "Video Tutorial"}</IonLabel>
       </IonItem>
       <IonItem button={isPlatform('desktop') ? true : false}         color={colori}
       

        onClick={() => {
         history.push(`${url}/about`);
         setDrawer(false);
        }}
       >
        <InfoSharp style={{ paddingRight: "10px" }} />
        <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "ऐप के बारे मे" : "About"}</IonLabel>
       </IonItem>

       <IonItem button={isPlatform('desktop') ? true : false}         color={colori}
       
        onClick={async () => {
          if(isPlatform("desktop")){
            navigator.clipboard.writeText("Vaishnava Songs App in English and Hindi with Audio, Word-to-Word Meanings, and Much More!!!\nAll the below Apps (including the Web App) work offline and doesn't display any ads\n\nAndroid App: https://tinyurl.com/vsdroid\niOS App: https://tinyurl.com/vsapple\nWeb App: https://vsnectar.web.app\n\nPlease share this message with as many devotees as possible.\n")
            .then(() => {
              setToastText("Text copied to clipboard. You can now paste it wherever you want to share it.");
              setShowToast(true);
            })
            .catch((error) => {
              console.error('Could not copy text: ', error);
            });
          }else{
            try{
          await Share.share({
            title: "Share this Treasure",
            text: "Vaishnava Songs App in English and Hindi with Audio, Word-to-Word Meanings, and Much More!!!\nAll the below Apps (including the Web App) work offline and doesn't display any ads\n\nAndroid App: https://tinyurl.com/vsdroid\niOS App: https://tinyurl.com/vsapple\nWeb App: https://vsnectar.web.app\n\nPlease share this message with as many devotees as possible.\n",
            dialogTitle: "Share this app with devotees",
           });
          }catch(err){
            console.error(err)
          }
          }
        }}
       >
        <ShareSharp style={{ paddingRight: "10px" }} />
        <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "शेयर ऐप" : "Share the App"}</IonLabel>
       </IonItem>
       {isPlatform('desktop') ? <>
       <IonItem button={isPlatform('desktop') ? true : false}         color={colori}
       
        onClick={() => {
        
          window.location.href = "https://play.google.com/store/apps/details?id=com.rahulkudum.vaisnava_songs";
           
        }}
       >
        <IonIcon icon={logoGooglePlaystore} style={{ paddingRight: "10px", color:color4 }} />
        <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "Android ऐप" : "Android App"}</IonLabel>
       </IonItem>
       <IonItem button={isPlatform('desktop') ? true : false}         color={colori}
       
        onClick={() => {
            window.location.href = "https://apps.apple.com/app/vaishnava-songs-with-audio/id6447004785";
        }}
       >
        <IonIcon icon={logoAppleAppstore} style={{ paddingRight: "10px", color:color4 }} />
        <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "iOS ऐप" : "iOS App"}</IonLabel>
       </IonItem>
       </> : <IonItem button={isPlatform('desktop') ? true : false}         color={colori}
       
        onClick={() => {
          if(isPlatform("mobileweb")){
            if (isPlatform("ios")) {
              window.location.href = "https://apps.apple.com/app/vaishnava-songs-with-audio/id6447004785";
            } else {
              window.location.href = "https://play.google.com/store/apps/details?id=com.rahulkudum.vaisnava_songs";
            }
          }else{
            LaunchReview.launch();
          }
        }}
       >
        {isPlatform("ios") ? <IonIcon icon={logoAppleAppstore} style={{ paddingRight: "10px", color:color4 }} /> : <IonIcon icon={logoGooglePlaystore} style={{ paddingRight: "10px", color:color4 }} />}
        <IonLabel style={{ fontFamily: `${fon}` }}>{isPlatform("mobileweb") ? (hindit ? "इंस्टॉल ऐप" : "Install the App") : (hindit ? "रेट एप" : "Rate the App")}</IonLabel>
       </IonItem>}
       <IonItem button={isPlatform('desktop') ? true : false}         color={colori}
       
        onClick={() => {
         history.push(`${url}/donate`);
         setDrawer(false);
        }}
       >
        <VolunteerActivismSharp style={{ paddingRight: "10px" }} />
        <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "दान" : "Donate"}</IonLabel>
       </IonItem>
       <IonItem button={isPlatform('desktop') ? true : false}         color={colori}
       onClick={() => {
        history.push(`${url}/privacy`);
        setDrawer(false);
       }}
      >
       <SecuritySharp style={{ paddingRight: "10px" }} />
       <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "प्राइवेसी पॉलिसी" : "Privacy Policy"}</IonLabel>
      </IonItem>
       <IonItem button={isPlatform('desktop') ? true : false} color={colori} href="mailto:vaishnavasongs108@gmail.com">
        <Feedback style={{ paddingRight: "10px" }} />
        <IonLabel style={{ fontFamily: `${fon}` }}>
         {hindit ? "प्रतिक्रिया / प्रश्न" : "Feedback / Queries"} <p>({hindit ? "एक दिन के भीतर जवाब देंगे" : "replied within a day"})</p>
        </IonLabel>
       </IonItem>
      </SwipeableDrawer>
      <motion.div exit={{ opacity: 0 }} animate={{ opacity: 1 }} initial={{ opacity: 0 }} transition={{ type: "linear", duration: 0 }}>
       {searchState && !hindit ? (
        <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}`, fontSize: "16px" }}>
         <IonLabel style={{ fontFamily: `${fon}` }}>{searchText ? "Title" : "Recent Searches"}</IonLabel>
        </IonItemDivider>
       ) : null}

       <div className="whole">
        <div className={searchState ? "" : "list"}>
         {iskcon.songs.map((td, i) => {
          function next() {
            if(searchState) {
              setSearchHistory(prev=>{
                let dum = [...prev]
                let index = dum.indexOf(searchText);
                if (index !== -1) dum.splice(index, 1)
                for (let k=0; k<dum.length; k++) {
                  if(dum[k]===searchText) {
                    dum.slice(k,1)
                    break
                  }
                }
                dum.push(searchText)
                if(dum.length > 10) {
                  return dum.slice(1)
                }
                return dum
               })
            }
           history.push(`${url}/songs/${td.name}_${td.book ?? ""}`);
          }

          if (!searchState) {
           if (filter === "all") {
            if (hindit) {
             if (i === 0 || td.name[0] !== iskcon.songs[i - 1].name[0])
              return (
               <div key={i}>
                <IonItemDivider id={td.name[0]} style={{ backgroundColor: `${color2}`, color: `${color3}`, fontSize: "16px" }}>
                 <IonLabel style={{ fontFamily: `${fon}` }}>{td.name[0]}</IonLabel>
                </IonItemDivider>

                {td.hindi ? (
                 <IonItem button={isPlatform('desktop') ? true : false} color={colori} onClick={next}>
                  <IonLabel style={{ fontFamily: `${fon}` }}>
                   <h2>{td.hindi}</h2>
                   <p style={{ fontSize: "11px", color: color4 }}>{td.hauthor !== "" ? td.hauthor : ""}</p>
                  </IonLabel>
                 </IonItem>
                ) : null}
               </div>
              );

             if (td.hindi)
              return (
               <IonItem key={i} button={isPlatform('desktop') ? true : false} color={colori} onClick={next}>
                <IonLabel style={{ fontFamily: `${fon}` }}>
                 <h2>{td.hindi}</h2>
                 <p style={{ fontSize: "11px", color: color4 }}>{td.hauthor !== "" ? td.hauthor : ""}</p>
                </IonLabel>
               </IonItem>
              );
            } else {
             if (i === 0 || td.name[0] !== iskcon.songs[i - 1].name[0])
              return (
               <div key={i}>
                <IonItemDivider id={td.name[0]} style={{ backgroundColor: `${color2}`, color: `${color3}`, fontSize: "16px" }}>
                 <IonLabel style={{ fontFamily: `${fon}` }}>{td.name[0]}</IonLabel>
                </IonItemDivider>

                <IonItem button={isPlatform('desktop') ? true : false} color={colori} onClick={next}>
                 <IonLabel style={{ fontFamily: `${fon}` }}>
                  <h2>{td.name}</h2>
                  <p style={{ fontSize: "11px", color: color4 }}>{td.author !== "" ? td.author : ""}</p>
                 </IonLabel>
                </IonItem>
               </div>
              );

             return (
              <IonItem key={i} button={isPlatform('desktop') ? true : false} color={colori} onClick={next}>
               <IonLabel style={{ fontFamily: `${fon}` }}>
                <h2>{td.name}</h2>
                <p style={{ fontSize: "11px", color: color4 }}>{td.author !== "" ? td.author : ""}</p>
               </IonLabel>
              </IonItem>
             );
            }
           }
          }

          if (searchState && searchText) {
           if (hindit) {
            if (td.state && td.hindi) {
             return (
              <IonItem key={i} button={isPlatform('desktop') ? true : false} color={colori} onClick={next}>
               <IonLabel style={{ fontFamily: `${fon}` }}>
                <h2>{td.hindi}</h2>
                <p style={{ fontSize: "11px", color: color4 }}>
                 {td.hauthor !== "" ? td.hauthor : ""} ({td.name})
                </p>
               </IonLabel>
              </IonItem>
             );
            }
           } else {
            if (td.state) {
             return (
              <IonItem key={i} button={isPlatform('desktop') ? true : false} color={colori} onClick={next}>
               <IonLabel style={{ fontFamily: `${fon}` }}>
                <h2>{td.name}</h2>
                <p style={{ fontSize: "11px", color: color4 }}>
                 {td.author !== "" ? td.author : ""} {td.offical ? `(${td.offical})` : null}
                </p>
               </IonLabel>
              </IonItem>
             );
            }
           }
          }
          return null
         })}
        </div>
        {!searchState && filter === "all" ? (
         <>{isPlatform("ios")  && !isPlatform("mobileweb") ? <div className="scrollc lhide iphonescroll">
         <div className="iphones"></div>
         <div className="scroll">
          {scrollBar.map((ab,i) => {
           return (
            <button
             onClick={() => {
              const section = document.querySelector(`#${ab}`);
              if (section) {
               section.scrollIntoView({ block: "start", inline: "nearest" });
              }
             }}
             key={i}
             style={{ color: `${clr === "5" || clr === "6" ? "white" : "black"}`, backgroundColor: `${(clr === "5" || clr === "6") ? "#181818" : (clr === "1" ? "#F0F8FF99" : "#FFFFCC99")}` }}
            >
             {ab}
            </button>
           );
          })}
         </div>
         <div style={{ height: "56px", zIndex: "-1" }}></div>
        </div> : <div className="scrollc lhide">
          <div style={{ height: "58px", zIndex: "-1" }}></div>
          <div className="scroll">
           {scrollBar.map((ab, i) => {
            return (
             <button
             key={i}
              onClick={() => {
               const section = document.querySelector(`#${ab}`);
               if (section) {
                if (isPlatform("mobileweb")){
                section.scrollIntoView({ block: "center", inline: "nearest" });
                }else{
                  section.scrollIntoView({ block: "start", inline: "nearest" });
                }
               }
              }}
              style={{ color: `${clr === "5" || clr === "6" ? "white" : "black"}`, backgroundColor: `${(clr === "5" || clr === "6") ? "#181818" : (clr === "1" ? "#F0F8FF99" : "#FFFFCC99")}` }}
             >
              {ab}
             </button>
            );
           })}
          </div>
          <div style={{ height: "56px", zIndex: "-1" }}></div>
         </div>}</>
        ) : null}
       </div>

       {searchState && !searchText ? (
        <div>
          {searchHistory.slice().reverse().map((td, i)=>{
            return(
              <IonItem key={i} button={isPlatform('desktop') ? true : false} color={colori} onClick={()=>{search(td)}}>
              <IonLabel style={{ fontFamily: `${fon}` }}>
               <h2>{td}</h2>
              </IonLabel>
             </IonItem>
            )
          })}
        </div>
       ) : null}

       {searchState && searchText && !hindit ? (
        <div>
         <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}`, fontSize: "16px" }}>
          <IonLabel style={{ fontFamily: `${fon}` }}>Verses</IonLabel>
         </IonItemDivider>

         {searchList.map((val, i) => {
          if ((val.line.charCodeAt(1) < 48 || val.line.charCodeAt(1) > 57)) {
            let sentence = val.line
            const beforeHighlight = sentence.slice(0, val.start);
            const highlighted = sentence.slice(val.start, val.end);
            const afterHighlight = sentence.slice(val.end);
           return (
            <IonItem key={i} button={isPlatform('desktop') ? true : false}              color={colori}
            
             onClick={() => {
              if(searchState) {
                setSearchHistory(prev=>{
                  let dum = [...prev]
                  let index = dum.indexOf(searchText);
                  if (index !== -1) dum.splice(index, 1)
                  for (let k=0; k<dum.length; k++) {
                    if(dum[k]===searchText) {
                      dum.slice(k,1)
                      break
                    }
                  }
                  dum.push(searchText)
                  if(dum.length > 10) {
                    return dum.slice(1)
                  }
                  return dum
                 })
              }
                history.push(`${url}/songs/${iskcon.songs[val.index].name}_${iskcon.songs[val.index].book ?? ""}`);
             }}
            >
             <IonLabel style={{ fontFamily: `${fon}` }}>
             <h2>
              {beforeHighlight}
              <span style={{color: "#1e88e5"}}>{highlighted}</span>
              {afterHighlight}
              </h2>
              <p style={{ fontSize: "11px", color: color4 }}>{iskcon.songs[val.index].name}</p>
             </IonLabel>
            </IonItem>
           );
          }
          return null
         })}

         <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}`, fontSize: "16px" }}>
          <IonLabel style={{ fontFamily: `${fon}` }}>Translations</IonLabel>
         </IonItemDivider>

         {searchList.map((val, i) => {
          if (val.line.charCodeAt(1) >= 48 && val.line.charCodeAt(1) <= 57) {
            let sentence = val.line
            const beforeHighlight = sentence.slice(0, val.start).slice(3);
            const highlighted = sentence.slice(val.start, val.end);
            const afterHighlight = sentence.slice(val.end);

           return (
            <IonItem key={i} button={isPlatform('desktop') ? true : false}              color={colori}
            
             onClick={() => {
              if(searchState) {
                setSearchHistory(prev=>{
                  let dum = [...prev]
                  let index = dum.indexOf(searchText);
                  if (index !== -1) dum.splice(index, 1)
                  for (let k=0; k<dum.length; k++) {
                    if(dum[k]===searchText) {
                      dum.slice(k,1)
                      break
                    }
                  }
                  dum.push(searchText)
                  if(dum.length > 10) {
                    return dum.slice(1)
                  }
                  return dum
                 })
              }
                history.push(`${url}/songs/${iskcon.songs[val.index].name}_${iskcon.songs[val.index].book ?? ""}`);
             }}
            >
             <IonLabel style={{ fontFamily: `${fon}` }}>
              <h2>
              {beforeHighlight}
              <span style={{color: "#1e88e5"}}>{highlighted}</span>
              {afterHighlight}
              </h2>
              <p style={{ fontSize: "11px", color: color4 }}>{iskcon.songs[val.index].name}</p>
             </IonLabel>
            </IonItem>
           );
          }
          return null
         })}
        </div>
       ) : null}
       <div>{!searchState && filter === "authors" ? <AuthorFilter /> : null}</div>
       <div>{!searchState && filter === "pranama" ? <PranamaFilter /> : null}</div>
       <div>{!searchState && filter === "temple" ? <TempleFilter /> : null}</div>
       <div>{!searchState && filter === "astakams" ? <AstakamFilter /> : null}</div>
      </motion.div>
      <IonToast isOpen={showToast} onDidDismiss={() => setShowToast(false)} message={toastText} duration={4000} />
      <Menu  classes={{ paper: classes.menu }} id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
       
         <IonItem button={isPlatform('desktop') ? true : false}          
         
          onClick={() => {
           setAnchorEl(null);
           setFilter("all");
          }}
         >
          <IonLabel style={{ fontFamily: `${fon}` }}> Alphabetical</IonLabel>
         </IonItem>
       
        
         <IonItem button={isPlatform('desktop') ? true : false}        
         
          onClick={() => {
           setAnchorEl(null);
           setFilter("authors");
          }}
         >
          <IonLabel style={{ fontFamily: `${fon}` }}> Authors</IonLabel>
         </IonItem>
       
         <IonItem button={isPlatform('desktop') ? true : false}         
         
          onClick={() => {
           setAnchorEl(null);
           setFilter("temple");
          }}
         >
          <IonLabel style={{ fontFamily: `${fon}` }}>Temple Songs</IonLabel>
         </IonItem>
        
         <IonItem button={isPlatform('desktop') ? true : false}          
         
          onClick={() => {
           setAnchorEl(null);
           setFilter("pranama");
          }}
         >
          <IonLabel style={{ fontFamily: `${fon}` }}>Pranama Mantras </IonLabel>
         </IonItem>
       
         <IonItem button={isPlatform('desktop') ? true : false}         
          lines="none"
         
          onClick={() => {
           setAnchorEl(null);
           setFilter("astakams");
          }}
         >
          <IonLabel style={{ fontFamily: `${fon}` }}>Ashtakams & Stotras</IonLabel>
         </IonItem>
      
       </Menu>
      

      </IonContent>
      {searchState ? null : (
        <IonFooter>
       <IonToolbar mode="md" color={colorh}>
        <IonSegment value="default">
         <IonSegmentButton style={{ minWidth: 0 }} value="default" onClick={() => history.push("/home")}>
          <QueueMusicSharp />
         </IonSegmentButton>
         {!hindit ? (
          <>
           <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/books")}>
            <MenuBookSharp />
           </IonSegmentButton>
           <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/sp")}>
            <img alt="SP" src={SP} style={{ height: "40px", backgroundColor: colorsp, borderRadius:"50%" }} />
           </IonSegmentButton>
           <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/sb")}>
            <AutoStoriesSharp />
           </IonSegmentButton>
          </>
         ) : <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/sp")}>
         <img alt="SP" src={SP} style={{ height: "40px", backgroundColor: colorsp, borderRadius:"50%" }} />
        </IonSegmentButton>}

         <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/lists")}>
          <PlayLessonSharp />
         </IonSegmentButton>
        </IonSegment>
       </IonToolbar>
       </IonFooter>
      )}
      </IonPage> 
      </div>

   
    <Switch location={location}>
     <Route exact path={path}>
     </Route>
     <Route path={`${path}/songs/:ind`}>
      <Csong />
     </Route>
     <Route path={`${path}/about`}>
      <About />
     </Route>
     <Route path={`${path}/donate`}>
      <Donate />
     </Route>
     <Route path={`${path}/privacy`}>
      <Privacy />
     </Route>
     <Route path={`${path}/terms`}>
      <Terms />
     </Route>
     <Route path={`${path}/settings`}>
      <Settings />
     </Route>
    </Switch>
    {location.pathname.indexOf("songs") === -1 && !searchState ? <div style={{ height: "56px" }}></div> : null}
    </>
   </AnimatePresence>
  </div>
 );
}

export default Csub;
